module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Lunch_Saturday.84115170.jpg";